/* eslint-disable @typescript-eslint/no-explicit-any */
import { GetServerSideProps } from 'next';

import { PageRendererComponent, getProcessEnvs, prePageCall, canUseDOM } from '@marriott/mi-headless-utils';
import operationSignatures from '../_constants/operationSignatures.json';
import { FEATURE_FLAGS, fetchFlag, TARGETS } from '@marriott/mi-feature-flag-utils';
import { envVarKeys } from '../_constants/envVarKeys';

if (canUseDOM) window.$ = window.jQuery = require('jquery-slim/dist/jquery.slim.min.js');

function pageRenderer(props) {
  return <PageRendererComponent {...props} />;
}

//Any product specific page data apart from common data like session, datalayer
//can be returned from this function and the same is passed as props to the page Component
export const homepageSpecificData = async () => {
  const {
    NEXT_PUBLIC_SUBMIT_SEARCH_URL,
    NEXT_PUBLIC_AVAILABILITY_SEARCH_URL,
    GOOGLE_MAP_API_KEY,
    BAIDU_MAP_API_KEY = null,
    UXL_IMAGE_CACHE_DOMAIN = null,
    SESSION_GET_CALL_URL_CLIENT,
    SESSION_APP_GET_CALL_V1_URL,
    DEPLOYED_ENV_CONFIG,
    TARGET_PROPERTY_TOKEN,
    NEXT_PUBLIC_FETCH_OFFERS_API_URL,
    SESSION_APP_POST_CALL_URL,
    INJECT_BRAND_CSS,
    NEXT_PUBLIC_PREFIX,
    GET_DESTINATION_TYPE_FLAG,
  } = getProcessEnvs();

  // Feature flag call for logo
  const featureFlagLogo = await fetchFlag(FEATURE_FLAGS.EXPERIENCE_MCOM_LOGO_AUTOMATION, {
    target: TARGETS.APP.HOMEPAGE_RENDERER,
  });
  // Feature flag call to get cardCarousel flag
  const featureFlags = await fetchFlag(FEATURE_FLAGS.EXPERIENCE_MCOM_CAROUSEL_LIGHTINING_VARIANTS, {
    target: TARGETS.APP.HOMEPAGE_RENDERER,
  });

  return {
    operationSignatures,
    productSpecificResponse: [],
    NEXT_PUBLIC_SUBMIT_SEARCH_URL,
    NEXT_PUBLIC_AVAILABILITY_SEARCH_URL,
    NEXT_PUBLIC_FETCH_OFFERS_API_URL,
    TARGET_PROPERTY_TOKEN,
    GOOGLE_MAP_API_KEY,
    BAIDU_MAP_API_KEY,
    UXL_IMAGE_CACHE_DOMAIN,
    SESSION_GET_CALL_URL_CLIENT,
    SESSION_APP_GET_CALL_V1_URL,
    SESSION_APP_POST_CALL_URL,
    DEPLOYED_ENV_CONFIG,
    INJECT_BRAND_CSS: INJECT_BRAND_CSS,
    buildInfo: {
      deployedEnvType: process.env.DEPLOYED_ENV_TYPE ?? null,
      deployedEnvConfig: process.env.DEPLOYED_ENV_CONFIG ?? null,
      jenkinsDeploymentBuild: process.env.JENKINS_DEPLOYMENT_BUILD ?? null,
    },
    featureFlagLogo,
    NEXT_PUBLIC_PREFIX,
    featureFlags,
    nextPublicEnvKeys: [...Object.keys(envVarKeys)],
    GET_DESTINATION_TYPE_FLAG,
  };
};

//Make pre page calls like session, datalayer, fetch model.json, producSpecifc data etc
//at server side and pass the data is passed as props to page component.
export const getServerSideProps: GetServerSideProps<any> = prePageCall(homepageSpecificData);
export default pageRenderer;
